import { CheckCircle } from "@mui/icons-material";
import { Box, Divider, Stack, Typography, styled } from "@mui/material";

const CountBadge = styled(Box)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 28,
  height: 28,
  borderRadius: "50%",
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  fontSize: "0.8125rem",
  fontWeight: 700,
}));

interface IOnboardingConfiguredListSectionProps {
  title: string;
  items: string[];
  showDivider?: boolean;
}

function OnboardingConfiguredListSection({
  title,
  items,
  showDivider = true,
}: IOnboardingConfiguredListSectionProps) {
  return (
    <Box>
      {showDivider && <Divider sx={{ mb: 2 }} />}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={1}
      >
        <Typography variant="subtitle1" fontWeight={600}>
          {title}
        </Typography>
        <CountBadge>{items.length}</CountBadge>
      </Stack>
      <Stack spacing={1.25}>
        {items.map((item) => (
          <Stack
            key={item}
            direction="row"
            spacing={1.5}
            alignItems="flex-start"
          >
            <CheckCircle
              sx={{
                fontSize: 20,
                color: "primary.main",
                mt: 0.15,
                flexShrink: 0,
              }}
            />
            <Typography variant="body2" color="text.primary">
              {item}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
}

export default OnboardingConfiguredListSection;
